<template>
  <div v-if="text" class="cc-consignes mb-3 px-3 py-2 text-left">
    <div class="cc-consignes-title mb-1">
      {{ $t("lang.label.cold_call_script.consignes_banner") }}
    </div>
    <div class="cc-scroll" style="max-height: 140px">
      <p class="cc-text">{{ text }}</p>
    </div>
  </div>
</template>

<script>
import "./coldCall.css";

export default {
  name: "ColdCallConsignes",
  props: {
    text: { type: String, default: "" },
  },
};
</script>

<style scoped>
/* Mismos colores que el tipo "reduce" de ClientBookingSignal.vue */
.cc-consignes {
  border-left: 4px solid #fd7e14;
  background: #fff5eb;
  border-radius: 0 4px 4px 0;
  color: #212529;
}
.cc-consignes-title {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: #fd7e14;
}
</style>
